export enum Policy {
  Any = 0,
  Manager = 1,
  BackOffice = 2,
  Payroll = 3,
  Admin = 4,
  SysAdmin = 5,
  LeadDriver = 6,
  Mechanic = 7,
  //Dispatcher = 8, //not fully implemented

  //Claims
  TruckPermissions = 20,
  SchedulePermissions = 21,
  RoutePermissions = 22,
  EmployeePermissions = 23
}

export const PolicyMapping: Record<Policy, string> = {
  [Policy.Any]: 'Any',
  [Policy.Manager]: 'Manager',
  [Policy.BackOffice]: 'Back Office',
  [Policy.Payroll]: 'Payroll',
  [Policy.Admin]: 'Administrator',
  [Policy.SysAdmin]: 'System Administrator',
  [Policy.LeadDriver]: 'Lead Driver',
  [Policy.Mechanic]: 'Mechanic',
  //[Policy.Dispatcher]: 'Dispatcher',

  //Claims
  [Policy.TruckPermissions]: 'Truck Permissions',
  [Policy.SchedulePermissions]: 'Schedule Permissions',
  [Policy.RoutePermissions]: 'Route Permissions',
  [Policy.EmployeePermissions]: 'Employee Permissions'
};
